import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useUserProfile } from '../../hooks/useUserProfile';
import { getDeviceFingerprint } from '../../utils/studentSecurity';
import ContentProtection from './ContentProtection';

/**
 * Blocks suspended students and pending devices; wraps portal in content protection.
 */
export function StudentPortalGuard({ children, protect = true }) {
  const { currentUser, isAdmin } = useAuth();
  const { profile, loading } = useUserProfile(currentUser?.uid);

  if (loading) {
    return (
      <div className="sba-loading-screen" style={{ padding: 48, textAlign: 'center', color: '#64748b' }}>
        Loading portal…
      </div>
    );
  }

  if (profile?.portalBlocked) {
    return <Navigate to="/portal-blocked" replace />;
  }

  const deviceId = getDeviceFingerprint();
  const approved = (profile?.approvedDevices || []).length === 0
    || (profile?.approvedDevices || []).includes(deviceId);
  const pending = profile?.pendingDeviceId && profile.pendingDeviceId === deviceId;

  if (!approved && pending) {
    return <Navigate to="/device-pending" replace />;
  }

  if (!isAdmin && protect) {
    return <ContentProtection>{children}</ContentProtection>;
  }

  return children;
}
